import { useState, useEffect, ReactNode } from "react";

import "./style.scss";
import LeftMenuLayout from "../layout/left-menu-layout.comp";
import GeneralMenu from "../admin/general-menu/general-menu.comp";
import { FirebaseAuthContainer } from "../../common/containers/auth/firebase-auth-container.util";
import { ThemeContainer } from "../../common/containers/theme/theme.container";

const GeneralMenuLayout = ({ children }: { children: ReactNode }) => {
    const { knowledgeBases, isSuperAdmin } = FirebaseAuthContainer.useContainer();
    const { devMode, leftMenuCollapsed } = ThemeContainer.useContainer();
    const [assistantAvailable, setAssistantAvailable] = useState<boolean>(false);

    useEffect(() => {
        if (!knowledgeBases.length) return;

        // TODO: get from page path params. User should choose it on Knowledge Bases page
        const knowledgeBase = knowledgeBases[0];
        setAssistantAvailable(knowledgeBase.status === "active");
    }, [knowledgeBases]);

    return (
        <LeftMenuLayout
            leftMenu={
                <GeneralMenu
                    collapsedType={leftMenuCollapsed}
                    assistantAvailable={assistantAvailable}
                    showPromptTuning={isSuperAdmin}
                    showForceSync={devMode}
                />
            }
        >
            {children}
        </LeftMenuLayout>
    );
};

export default GeneralMenuLayout;
